export default "__VITE_ASSET__Ble7Q5Aw__"